module.exports = __webpack_public_path__ + "fonts/TTHovesRegular.8fb06257.woff";